import React from 'react';
import {
  BackgroundImage,
  Box,
  Flex,
} from '@edreamsodigeo/prisma-design-system';
import PropTypes from 'prop-types';
import { Show } from '@edreamsodigeo/frontend-core';

const CardWithBackgroundImage = ({
  title,
  description,
  cta,
  backgroundImage,
  backgroundColor,
  backgroundPosition = 'right bottom',
  backgroundSize = 'auto',
  boxPaddingDesktop = '1x_big',
  marginTopCta = '',
  sx,
}) => {
  return (
    <Box position="relative" height="100%">
      <Box
        backgroundColor={backgroundColor}
        height="100%"
        width="100%"
        position="absolute"
        sx={sx}
      />
      <Box height="100%" position="relative">
        <BackgroundImage
          backgroundImage={`url('${backgroundImage}')`}
          backgroundRepeat="no-repeat"
          backgroundPosition={backgroundPosition}
          sx={{ backgroundSize: backgroundSize }}
        >
          <Box p={['big', boxPaddingDesktop]} height="100%">
            <Flex flexDirection="row" height="100%">
              <Flex flexDirection="column">
                <Box>{title}</Box>
                <Box pt="1x_small">{description}</Box>
                <Show when={!!cta}>
                  <Box pt="base" mt={marginTopCta}>
                    {cta}
                  </Box>
                </Show>
              </Flex>
              <Box minWidth="30%" />
            </Flex>
          </Box>
        </BackgroundImage>
      </Box>
    </Box>
  );
};

export default CardWithBackgroundImage;
CardWithBackgroundImage.propTypes = {
  title: PropTypes.node.isRequired,
  description: PropTypes.node.isRequired,
  cta: PropTypes.node,
  backgroundImage: PropTypes.string.isRequired,
  backgroundColor: PropTypes.string.isRequired,
  backgroundPosition: PropTypes.string,
  backgroundSize: PropTypes.string,
};
